import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import {
  HsLayerDescriptor,
  HsLayerUtilsService,
  HsLanguageService,
} from "hslayers-ng";

@Component({
  selector: "layer-list-item",
  templateUrl: "./layer-list-item.component.html",
  styleUrls: ["./layer-list-item.component.scss"],
})
export class LayerListItemComponent implements OnInit {
  @Input() layer: HsLayerDescriptor;
  @Output() layerVisiblityChanged = new EventEmitter<string>(); //output

  editorOpen = false;

  constructor(
    public HsLayerUtilsService: HsLayerUtilsService,
    public HsLanguageService: HsLanguageService
  ) {}

  ngOnInit(): void {}

  layerSelected(layer) {
    this.layerVisiblityChanged.emit(layer);
  }
}
